import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { faPatreon } from '@fortawesome/free-brands-svg-icons';

import AdSelf from './AdSelf';
import AdSense from './AdSense';

import login from '../util/login';

const DAY = 24 * 60 * 60 * 1000;

// wrapper component that will hide it's contents for anybody who shouldn't see ads
export default class Ad extends Component {
    componentDidMount() {
        login.addEventListener(this.handleLoginEvent);
    }

    componentWillUnmount() {
        login.removeEventListener(this.handleLoginEvent);
    }

    handleLoginEvent = () => {
        // if login status changes, we need to re-render
        this.setState({ loginEvent: Date.now() });
    }

    // hides the ad for a day if they click the hide button
    hide = () => {
        try {
            const hiddenOn = parseInt(sessionStorage.getItem('hidead'));
            if (!isNaN(hiddenOn) && hiddenOn + DAY > Date.now()) return true;
        } catch (e) {

        }

        sessionStorage.removeItem('hidead');
        return false;
    }

    close = () => {
        sessionStorage.setItem('hidead', Date.now());
        this.setState({ hidead: Date.now() }); // re-render
    }

    support = () => {
        window.open('https://www.patreon.com/shoogen', 'external');
    }

    // determines if we should insert AdSelf instead of regular ad
    adself = () => {
        // self-ad in header only
        if (this.props.slot !== 'header') return false;

        // TODO convert previous to an expire date, show reminder for up to 1 month
        if (login.previous()) return true; // reminder to re-subscribe

        // save self-ad setting for duration of session
        let selfad = sessionStorage.getItem('selfad');
        if (selfad) return selfad === 'true';

        selfad = Math.random() < .25;
        sessionStorage.setItem('selfad', String(selfad));
        return selfad;
    }

    render() {
        if (login.supporter()) return null;
        if (this.hide()) return null;

        // TODO if ads are blocked, fallback to AdSelf - or request whitelist

        const adself = this.adself();
        return (
            <>
                <div className="mt-3">
                    {adself ? <AdSelf /> : <AdSense slot={this.props.slot} />}
                </div>
                <div className="mx-auto">
                    <button type="button" className="btn btn-link" onClick={this.close}><small className="text-nowrap"><FontAwesomeIcon icon={faTimes} className="mr-1" />Hide This Ad</small></button>
                    {adself ? null : <button type="button" className="btn btn-link" onClick={this.support}><small className="text-nowrap"><FontAwesomeIcon icon={faPatreon} className="mr-1" />Become a Patron</small></button>}
                </div>
            </>
        )
    }
}